import {I18n} from 'aws-amplify/utils';

import {
    Menu,
    TextInput,
    Checkbox,
    ScrollArea,
    Text
} from '@mantine/core';
import {AiOutlineTag, AiOutlineSearch} from 'react-icons/ai'
import {useDisclosure} from "@mantine/hooks";

import {
    FlexiButton
} from "@flexinet/ui-components";
import {useMessage} from "../../messages/hooks/useMessage.ts";
import {useTags} from "../hooks/useTags.ts";
import {useEffect, useState} from "react";
import {Tag} from "../types.ts";


export const TagRecordButton = ({
                                    disabled = false,
                                    record,
                                    handleConfirm,
                                }: {
    disabled?: boolean,
    record: { id: string, tagIds?: string[] },
    handleConfirm: () => void,
}) => {

    const {
        updateRecord,
    } = useMessage(record.id as string)

    const {
        items: tags,
        fetchRecords: fetchTags
    } = useTags();

    const [opened, {
        open,
        close
    }] = useDisclosure(false);
    
    const [searchValue, setSearchValue] = useState('');
    const [selectedTagIds, setSelectedTagIds] = useState<string[]>(record.tagIds || []);

    useEffect(() => {
        fetchTags();
    }, []);

    useEffect(() => {
        setSelectedTagIds(record.tagIds || []);
    }, [record.tagIds]);

    const filteredTags = tags.filter((tag: Tag) => 
        tag.name?.toLowerCase().includes(searchValue.toLowerCase())
    );


    const handleTagToggle = (tagId: string) => {
        const newSelectedTagIds = selectedTagIds.includes(tagId)
            ? selectedTagIds.filter(id => id !== tagId)
            : [...selectedTagIds, tagId];
        
        setSelectedTagIds(newSelectedTagIds);
        
        const {
            selected,
            ...rest
        } = record as { id: string, tagIds?: string[] } & { selected: boolean };
        
        const updated = {
            ...rest,
            tagIds: newSelectedTagIds
        };
        
        updateRecord(updated);
        handleConfirm();
    };

    return (
        <Menu
            opened={opened}
            onClose={close}
            position="bottom-start"
            width={300}
            shadow="md"
            withinPortal
            offset={5}
        >
            <Menu.Target>
                <div>
                    <FlexiButton
                        disabled={disabled}
                        leftSection={<AiOutlineTag/>}
                        variant="subtle"
                        onClick={open}
                    >
                        {I18n.get('Tag')}
                    </FlexiButton>
                </div>
            </Menu.Target>

            <Menu.Dropdown>
                <TextInput
                    placeholder={I18n.get('Search tags...')}
                    value={searchValue}
                    onChange={(event) => setSearchValue(event.currentTarget.value)}
                    leftSection={<AiOutlineSearch size={16} />}
                    mb="xs"
                />
                
                <ScrollArea.Autosize mah={200}>
                    {filteredTags.length === 0 ? (
                        <Text size="sm" c="dimmed" p="xs">
                            {searchValue ? I18n.get('No tags found') : I18n.get('No tags available')}
                        </Text>
                    ) : (
                        filteredTags.map((tag: Tag) => (
                            <Menu.Item
                                key={tag.id}
                                onClick={() => handleTagToggle(tag.id)}
                                leftSection={
                                    <Checkbox
                                        checked={selectedTagIds.includes(tag.id)}
                                        onChange={() => {}} // Handled by Menu.Item onClick
                                        size="sm"
                                    />
                                }
                            >
                                {tag.name}
                            </Menu.Item>
                        ))
                    )}
                </ScrollArea.Autosize>
            </Menu.Dropdown>
        </Menu>
    );
};



